module.exports = __webpack_public_path__ + "static/media/ariel.b0297f79.png";